export class Notification {
  public id: string;
  public date: string;
  public message: string;
  public type: boolean = false;
  constructor(data: any) {
    this.id = data.notificationid ? data.notificationid : "";
    this.date = data.notificationdate
      ? this.convertDate(data.notificationdate)
      : "";
    this.message = data.message ? data.message : "";
    this.type = data.type ? data.type : "";
  }
  convertDate(dateObject) {
    let date = new Date(dateObject);
    return (
      date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
    );
  }
}

export class ProjectDetails {
  public projectName: string;
  public projectId: any;
  public task = [];
  public newProject: boolean;
  public taskList: Array<any> = [];
  public programName: string;
  public projectManager: string;
  public businessUnit: string;
  public wbscode:any;
  constructor(data: any, status, firstDate, taskList, businessUnit, where?) {
    this.projectName = data.projectname ? data.projectname : "";
    this.projectId = data.projectID ? data.projectID : "";
    this.programName = data.programName ? data.programName : "";
    this.projectManager = data.projectManager ? data.projectManager : "";
    this.businessUnit = data.businessUnit;
    this.wbscode=data.wbscode?data.wbscode:"";
    // console.log(where,businessUnit);
    if (data.tasklist) {
      for (let i = 0; i < data.tasklist.length; i++) {
        if (businessUnit === "accenture") {
          this.task.push(new TaskDetailsAccenture(data.tasklist[i], status));
        } else if (
          businessUnit === "ipdo" ||
          businessUnit === "chinateam" ||
          businessUnit === "aps"
        ) {
          this.task.push(new TaskDetails(data.tasklist[i], status, "", where));
        } else if (businessUnit === "biologics") {
          this.task.push(
            new TaskDetailsBiologics(data.tasklist[i], status, "", where)
          );
        }
      }
    } else {
      if (businessUnit === "accenture") {
        this.task.push(new TaskDetailsAccenture("", "", firstDate));
      } else if (
        businessUnit === "ipdo" ||
        businessUnit === "chinateam" ||
        businessUnit === "aps"
      ) {
        this.task.push(new TaskDetails("", "", firstDate));
      } else if (businessUnit === "biologics") {
        this.task.push(new TaskDetailsBiologics("", "", firstDate));
      }
    }
    this.newProject = data.newProject || undefined;
    this.taskList = taskList || [];
    this.task.forEach((element) => {
      this.taskList.forEach((value) => {
        if (element.activityID === value.activityID) {
          element.taskType = value.activityType;
          element.taskDescription = value.activityDescription;
        }
      });
    });
  }
}

export class Locked {
  public locked: any[] = [];
}

// digit level class change string 00:00 to number 0 to make it correct
// class for Accenture
export class TaskDetailsAccenture {
  newTicket: boolean;
  public taskType: string;
  public ticketNumber: string;
  public activityDescription: string;
  public supportGroup: string;
  public taskId: any;
  public activityID: any;
  public sunday: any;
  public monday: any;
  public tuesday: any;
  public wednesday: any;
  public thursday: any;
  public friday: any;
  public saturday: any;
  public approvalStatus: any;
  public total: any = 0;
  public firstDay: any;
  public lastDay: any;
  public locked: any[] = [];
  public weak: any = [];
  public weakFlag: boolean = false;
  public WeakDetails: any = [
    {
      day: "sunday",
      FilledHrs: 0,
      leaveType: "",
      status: "",
      flag: false,
      filled: false,
    },
    {
      day: "monday",
      FilledHrs: 0,
      leaveType: "",
      status: "",
      flag: false,
      filled: false,
    },
    {
      day: "tuesday",
      FilledHrs: 0,
      leaveType: "",
      status: "",
      flag: false,
      filled: false,
    },
    {
      day: "wednesday",
      FilledHrs: 0,
      leaveType: "",
      status: "",
      flag: false,
      filled: false,
    },
    {
      day: "thursday",
      FilledHrs: 0,
      leaveType: "",
      status: "",
      flag: false,
      filled: false,
    },
    {
      day: "friday",
      FilledHrs: 0,
      leaveType: "",
      status: "",
      flag: false,
      filled: false,
    },
    {
      day: "saturday",
      FilledHrs: 0,
      leaveType: "",
      status: "",
      flag: false,
      filled: false,
    },
  ];
  public ticketDescription: any;
  public isTotalExist: boolean = false;

  constructor(data: any, status, firstDate?) {
    // console.log(data)
    let curr;
    if (data) {
      curr = new Date(data.taskDetails[0].dateDetails.date);
    } else {
      curr = new Date(firstDate);
    }
    let first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    let last = first + 6; // last day is the first day + 6

    this.firstDay = new Date(curr.setDate(first)).toUTCString();

    let count = 0;
    let startDate = new Date(this.firstDay);
    while (count < 6) {
      this.lastDay = new Date(startDate.setDate(startDate.getDate() + 1));
      count++;
    }
    for (let i = 0; i < 7; i++) {
      this.weak[i] = this.getDateDay(i);
      this.locked[i] = 100;
    }

    this.activityID = data.taskID ? data.taskID : "";
    this.taskType = data.taskname ? data.taskname : "";
    this.ticketNumber = data.ticketNumber ? data.ticketNumber.trim() : "";
    this.supportGroup = data.supportGroup ? data.supportGroup : "";
    this.ticketDescription = data.ticketDescription
      ? data.ticketDescription
      : "";
    if (data.taskDetails) {
      for (let k = 0; k < data.taskDetails.length; k++) {
        let day = new Date(data.taskDetails[k].dateDetails.date);
        for (let j = 0; j < 7; j++) {
          if (this.weak[j].getDate() == day.getDate()) {
            this.WeakDetails[j].FilledHrs =
              this.WeakDetails[j].FilledHrs == 0
                ? data.taskDetails[k].filledHrs
                  ? Number(data.taskDetails[k].filledHrs)
                  : 0
                : this.WeakDetails[j].FilledHrs +
                  Number(data.taskDetails[k].filledHrs);
            if (data.taskDetails[k].filledHrs != 0) {
              this.WeakDetails[j].filled = true;
            }
            this.WeakDetails[j].leaveType = data.taskDetails[k].leaveType
              ? data.taskDetails[k].leaveType
              : "";
            this.WeakDetails[j].status =
              data.taskDetails[k].approvalStatus.status;
          } else {
            //    this.WeakDetails[j].status = data.taskDetails[k].approvalStatus.status;
            //this.WeakDetails[j].status = null;
          }
          if (
            this.WeakDetails[j].status == "0" ||
            this.WeakDetails[j].status == 2
          ) {
            this.weakFlag = true;
          }
        }
      }
    }
    for (let i = 0; i < 7; i++) {
      this.total += Number(this.WeakDetails[i].FilledHrs);
      if (this.total > 0) {
        this.isTotalExist = true;
      }
    }
  }

  getDateDay(number) {
    let date = new Date(this.firstDay);
    date.setDate(new Date(this.firstDay).getDate() + number);
    // return date.getDate();
    return date;
  }
}

// class for IPDO
export class TaskDetails {
  newTicket: boolean;
  public taskType: string;
  public taskDescription: string;
  public ticketNumber: string;
  public ticketDescription: string;
  public supportGroup: string;
  public taskId: any;
  public activityID: any;
  public sunday: any;
  public monday: any;
  public tuesday: any;
  public wednesday: any;
  public thursday: any;
  public friday: any;
  public saturday: any;
  public approvalStatus: any;
  public total: any = "00:00";
  public isTotalExist: boolean = false;
  public totalValue: number = 0;
  public targetID:any;
  public firstDay: any;
  public lastDay: any;
  public locked: any[] = [];
  public weak: any = [];
  public weakFlag: boolean = false;
  public isValidTask: boolean = true;
  public WeakDetails: any = [
    {
      day: "monday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "tuesday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "wednesday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "thursday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "friday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "saturday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "sunday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
    },
  ];

  constructor(data: any, status, firstDate?, where?) {
    let curr;
    if (where) {
      curr = new Date(where);
    } else if (data) {
      //curr = new Date(data.taskDetails[0].dateDetails.date);
      curr = new Date(new Date(data.taskDetails[0].dateDetails.date).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
    } else {
      curr = new Date(firstDate);
    }
    // console.log(curr)
    // let first = curr.getDate() - curr.getDay() + 1; // First day is the day of the month - the day of the week
    let first =
      curr.getDay() === 0
        ? curr.getDate() - 6
        : curr.getDate() - curr.getDay() + 1;
    let last = first + 6; // last day is the first day + 6

    this.firstDay = new Date(curr.setDate(first)).toUTCString();

    let count = 0;
    let startDate = new Date(this.firstDay);
    while (count < 6) {
      this.lastDay = new Date(startDate.setDate(startDate.getDate() + 1));
      count++;
    }
    for (let i = 0; i < 7; i++) {
      this.weak[i] = this.getDateDay(i);
      this.locked[i] = 100;
    }

    this.activityID = data.taskID ? data.taskID : "";
    this.taskType = data.taskname ? data.taskname : "";
    this.targetID=data.targetID?data.targetID:"";
    this.ticketNumber = data.ticketNumber ? data.ticketNumber : "";
    this.supportGroup = data.supportGroup ? data.supportGroup : "";
    this.ticketDescription = data.ticketDescription
      ? data.ticketDescription
      : "";
    this.taskDescription = data.taskdescription ? data.taskdescription : "";
    // console.log(data)
    if (data.taskDetails) {
      for (let k = 0; k < data.taskDetails.length; k++) {
        //let day = new Date(data.taskDetails[k].dateDetails.date);
        let day = new Date(new Date(data.taskDetails[k].dateDetails.date).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
        for (let j = 0; j < 7; j++) {
          if (this.weak[j].getDate() == day.getDate()) {
            // this.WeakDetails[j].FilledHrs = (this.WeakDetails[j].FilledHrs == 0) ? data.taskDetails[k].filledHrs ? Number(data.taskDetails[k].filledHrs) : 0 : this.WeakDetails[j].FilledHrs + Number(data.taskDetails[k].filledHrs);
            this.WeakDetails[j].FilledHrs = isNaN(data.taskDetails[k].filledHrs)
              ? data.taskDetails[k].filledHrs
              : "00:00";
            if (data.taskDetails[k].filledHrs != "00:00") {
              this.WeakDetails[j].filled = true;
            }
            this.WeakDetails[j].leaveType = data.taskDetails[k].leaveType
              ? data.taskDetails[k].leaveType
              : "";
            this.WeakDetails[j].status =
              data.taskDetails[k].approvalStatus.status;
            this.WeakDetails[j].message =
              data.taskDetails[k].approvalStatus.comment;
          } else {
            //    this.WeakDetails[j].status = data.taskDetails[k].approvalStatus.status;
            //this.WeakDetails[j].status = null;
          }
          if (
            this.WeakDetails[j].status == "0" ||
            this.WeakDetails[j].status == 2
          ) {
            this.weakFlag = true;
          }
        }
      }
    }
    for (let i = 0; i < 7; i++) {
      this.totalValue += this.convertHoursToMins(this.WeakDetails[i].FilledHrs);
      this.total = this.convertMinsToHrsMins(this.totalValue);
      if (this.totalValue > 0) {
        this.isTotalExist = true;
      }
    }
    //  this.total = data.total ? data.total : 0;
  }
  getDateDay(number) {
    //let date = new Date(this.firstDay);
    let date = new Date(new Date(this.firstDay).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
    date.setDate(new Date(this.firstDay).getDate() + number);
    // return date.getDate();
    return date;
  }

  convertHoursToMins(hrs) {
    const a = hrs.toString().split(":");
    let minutes = 0;
    if (a[1]) {
      minutes = +a[0] * 60 + +a[1];
    } else {
      minutes = +Number(a[0]) * 60;
    }
    return minutes;
  }

  convertMinsToHrsMins(mins) {
    const h: any = Math.floor(mins / 60);
    let m: any = mins % 60;
    m = Math.round(m);
    const hrs = h < 10 ? "0" + h : h;
    const mns = m < 10 ? "0" + m : m;
    return `${hrs}:${mns}`;
  }
}

// class for Biologics
export class TaskDetailsBiologics {
  newTicket: boolean;
  public taskType: string;
  public taskSpecifics: string;
  public taskDescription: string;
  public ticketNumber: string;
  public ticketDescription: string;
  public supportGroup: string;
  public taskId: any;
  public activityID: any;
  public sunday: any;
  public monday: any;
  public tuesday: any;
  public wednesday: any;
  public thursday: any;
  public friday: any;
  public saturday: any;
  public approvalStatus: any;
  public total: any = "00:00";
  public isTotalExist: boolean = false;
  public totalValue: number = 0;
  public firstDay: any;
  public lastDay: any;
  public locked: any[] = [];
  public weak: any = [];
  public weakFlag: boolean = false;
  public isValidTask: boolean = true;
  public WeakDetails: any = [
    {
      day: "monday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "tuesday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "wednesday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "thursday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "friday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "saturday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
      rejectedReason: "",
    },
    {
      day: "sunday",
      FilledHrs: "00:00",
      leaveType: "",
      status: "",
      flag: false,
      valid: true,
      filled: false,
      leaveApplied: false,
      message: "",
    },
  ];

  constructor(data: any, status, firstDate?, where?) {
    let curr;
    if (where) {
      curr = new Date(where);
    } else {
      if (data) {
        curr = new Date(data.taskDetails[0].dateDetails.date);
      } else {
        curr = new Date(firstDate);
      }
    }

    // console.log(curr)
    // let first = curr.getDate() - curr.getDay() + 1; // First day is the day of the month - the day of the week
    let first =
      curr.getDay() === 0
        ? curr.getDate() - 6
        : curr.getDate() - curr.getDay() + 1;
    let last = first + 6; // last day is the first day + 6

    this.firstDay = new Date(curr.setDate(first)).toUTCString();

    let count = 0;
    let startDate = new Date(this.firstDay);
    while (count < 6) {
      this.lastDay = new Date(startDate.setDate(startDate.getDate() + 1));
      count++;
    }
    for (let i = 0; i < 7; i++) {
      this.weak[i] = this.getDateDay(i);
      this.locked[i] = 100;
    }

    this.activityID = data.taskID ? data.taskID : "";
    this.taskType = data.taskname ? data.taskname : "";
    this.ticketNumber = data.ticketNumber ? data.ticketNumber : "";
    this.supportGroup = data.supportGroup ? data.supportGroup : "";
    this.ticketDescription = data.ticketDescription
      ? data.ticketDescription
      : "";
    this.taskDescription = data.taskdescription ? data.taskdescription : "";
    this.taskSpecifics = data.taskSpecifics ? data.taskSpecifics : "";
    if (data.taskDetails) {
      for (let k = 0; k < data.taskDetails.length; k++) {
        let day = new Date(data.taskDetails[k].dateDetails.date);
        for (let j = 0; j < 7; j++) {
          if (this.weak[j].getDate() == day.getDate()) {
            // this.WeakDetails[j].FilledHrs = (this.WeakDetails[j].FilledHrs == 0) ? data.taskDetails[k].filledHrs ? Number(data.taskDetails[k].filledHrs) : 0 : this.WeakDetails[j].FilledHrs + Number(data.taskDetails[k].filledHrs);
            this.WeakDetails[j].FilledHrs = isNaN(data.taskDetails[k].filledHrs)
              ? data.taskDetails[k].filledHrs
              : "00:00";
            if (data.taskDetails[k].filledHrs != "00:00") {
              this.WeakDetails[j].filled = true;
            }
            this.WeakDetails[j].leaveType = data.taskDetails[k].leaveType
              ? data.taskDetails[k].leaveType
              : "";
            this.WeakDetails[j].status =
              data.taskDetails[k].approvalStatus.status;
            this.WeakDetails[j].message =
              data.taskDetails[k].approvalStatus.comment;
          } else {
            //    this.WeakDetails[j].status = data.taskDetails[k].approvalStatus.status;
            //this.WeakDetails[j].status = null;
          }
          if (
            this.WeakDetails[j].status == "0" ||
            this.WeakDetails[j].status == 2
          ) {
            this.weakFlag = true;
          }
        }
      }
    }
    for (let i = 0; i < 7; i++) {
      this.totalValue += this.convertHoursToMins(this.WeakDetails[i].FilledHrs);
      this.total = this.convertMinsToHrsMins(this.totalValue);
      if (this.totalValue > 0) {
        this.isTotalExist = true;
      }
    }
    //  this.total = data.total ? data.total : 0;
  }
  getDateDay(number) {
    let date = new Date(this.firstDay);
    date.setDate(new Date(this.firstDay).getDate() + number);
    // return date.getDate();
    return date;
  }

  convertHoursToMins(hrs) {
    const a = hrs.toString().split(":");
    let minutes = 0;
    if (a[1]) {
      minutes = +a[0] * 60 + +a[1];
    } else {
      minutes = +Number(a[0]) * 60;
    }
    return minutes;
  }

  convertMinsToHrsMins(mins) {
    const h: any = Math.floor(mins / 60);
    let m: any = mins % 60;
    m = Math.round(m);
    const hrs = h < 10 ? "0" + h : h;
    const mns = m < 10 ? "0" + m : m;
    return `${hrs}:${mns}`;
  }
}

export class DayDetails {
  public status: string;
  public date: string;
  public timesheetID: string;
  public projectDetails: ProjectGroup[] = [];
  constructor(data: any, day) {
    this.status = data.approvalStatus.status ? data.approvalStatus.status : "";
    this.date = data.dateDetails.date ? data.dateDetails.date : "";
    this.timesheetID = data.timesheetID ? data.timesheetID : "";
    // this.projectDetails = data.projectDetails ? this.getIndividualProject(data.projectDetails, day, this.status) : '';
  }
  getIndividualProject(projectDetatils, day, status) {
    let projectArr: ProjectGroup[] = [];
    for (let i = 0; i < projectDetatils.length; i++) {
      for (let j = 0; j < projectDetatils.activity_hrs.length; j++) {
        projectArr.push(
          new ProjectGroup(day, status, projectDetatils.activity_hrs[i])
        );
      }
    }
  }
}

export class ProjectGroup {
  public status: string;
  public day: string;
  public projectName: string;
  public activityName: string;
  public filledHrs: any;
  constructor(data: any, day, activity) {
    this.status = data.approvalStatus.status ? data.approvalStatus.status : "";
    this.day = data.dateDetails.date ? data.dateDetails.date : "";
    this.projectName = data.timesheetID ? data.timesheetID : "";
    this.filledHrs = data.projectDetails
      ? this.getIndividualProject(data.projectDetails, day, this.status)
      : "";
  }
  getIndividualProject(projectDetatils, day, status) {}
}

export class DropDownProject {
  public Project: string;
  public projectID: string;
  public programName: string;
  public projectManager: string;
  public businessUnit: string;
  public wbscode:any;

  // constructor(data: any = {}) {
  //   this.projectID = data.projectID;
  //   this.Project = data.Project;
  //   this.programName = data.programName;
  //   this.projectManager = data.projectManager;
  //   this.businessUnit = data.businessUnit;
  // }
  constructor(data: any = {}) {
    this.projectID = data.project_id;
    this.Project = data.project_name;
    this.programName = data.programName;
    this.projectManager = data.project_manager["name"];
    this.businessUnit = data.business_unit;
    this.wbscode=data.wbs_code;
  }
}
export class DropDownMasterProject {
  public projectID: String;
  public projectName: String;
  public project_name: String;
  public plannedHours: number;
  public wbsCode: String;
  public projectManager: any;
  public projectType: String;
  public startDate: Date;
  public endDate: Date;
  public businessUnit: String;

  constructor(data: any = {}) {
    this.projectID = data.project_id;
    this.projectName = data.project_name;
    this.plannedHours = data.planned_hrs;
    this.wbsCode = data.wbs_code;
    this.projectManager = data.project_manager["name"];
    this.projectType = data.project_type;
    this.startDate = data.start_date;
    this.endDate = data.end_date;
    this.businessUnit = data.business_unit;
  }
}

export class DropDownTask {
  public activityType: string;
  public activityID: string;
  public activityDescription: string;
  public activityFlag: boolean;
  public selectedFlag: boolean;
  constructor(data: any = {}) {
    this.activityID = data.activityID;
    if (data && data.activityType.substring(0, 4) == "F - ") {
      this.activityFlag = false;
    } else {
      this.activityFlag = true;
    }
    this.selectedFlag = false;
    this.activityType = data.activityType;
    this.activityDescription = data.description ? data.description : "";
  }
}

export class DropDownTargetId {
  public targetID: string;
  public wbscode:string;
  constructor(data: any = {}) {
    this.targetID = data.targetID;
    this.wbscode=data.wbs_code;
}
}

export class NonIPDODropDownTask {
  public activityType: string;
  public activityID: string;
  public activityFlag: boolean;
  public selectedFlag: boolean;
  constructor(data: any = {}) {
    this.activityID = data.activityID;
    this.activityFlag = true;
    this.selectedFlag = false;
    this.activityType = data.activityType;
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/employee.interface.ts